// import { get, post, put, remove, patch } from "./base";
import { audiencesCreateWithoutTemplate } from "../router/routes";
import AudienceSlice from "../store/entities/audience/audience-slice.reducer";
import { get, post, remove, patch } from "./base";
import store from "../store";
import * as actions from "../store/entities/audience/audience.actions";

import url from "./url";
import objectToParams from "./params";
import queries from "./queries";

const { dispatch } = store;

async function getSamMapData({ params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audienceSamMap);
    dispatch(actions.getSamMapDataRequest());
    const response = await await get(query + stringParams, headers);
    dispatch(actions.getSamMapDataSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getSamMapDataFailed(err));
  }
}

async function getAudienceById({ id = "", params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiences, id);
    dispatch(actions.getAudienceByIdRequest());
    const response = await get(query + stringParams, headers);
    dispatch(actions.getAudienceByIdSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getAudienceByIdFailed(err));
  }
}

async function searchAudiences({ id = "", params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiences, id);
    dispatch(actions.searchAudienceRequest(params.search));
    const response = await get(query + stringParams, headers);
    dispatch(actions.searchAudienceRequestSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.searchAudienceRequestFailed(err));
  }
}

async function getAudiences({
  id = "",
  params = {},
  headers = {},
  isNewBackendSearchOrFiltering = false
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiences, id);
    dispatch(actions.getAudiencesRequest());
    const response = await get(query + stringParams, headers);
    dispatch(
      actions.getAudiencesRequestSuccess({
        data: response.results,
        next: response.next || "",
        isNewBackendSearchOrFiltering
      })
    );
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getAudiencesRequestFailed(err));
  }
}

async function addAudience({
  id = "",
  params = {},
  data = {},
  headers = {}
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiences, id);
    dispatch(actions.addAudienceRequest(data));
    const response = await post(query + stringParams, data, headers);
    dispatch(actions.addAudienceRequestSuccess(response));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getAudiencesRequestFailed(err));
  }
}

async function removeAudience({
  id = "",
  params = {},
  data = {},
  headers = {}
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiences, id);
    dispatch(actions.removeAudienceRequest());
    const response = await remove(query + stringParams, data, headers);
    dispatch(actions.removeAudienceRequestSuccess(id));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.removeAudienceRequestFailed(err));
  }
}

async function editAudience({
  id = "",
  params = {},
  data = {},
  headers = {}
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiences, id);
    dispatch(actions.editAudienceRequest());
    // const response = await put(query + stringParams, data, headers);
    const response = await patch(query + stringParams, data, headers);
    dispatch(actions.editAudienceRequestSuccess(response));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.editAudienceRequestFailed(err));
  }
}

async function getAudiencesCategories({ params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiencesCategories);
    dispatch(actions.getCategoriesRequest());
    const response = await get(query + stringParams, headers);
    return dispatch(actions.getCategoriesRequestSuccess(response));
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getCategoriesRequestFailed(err));
  }
}

async function getAudiencesSubcategories({ params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiencesSubcategories);
    dispatch(actions.getSubcategoriesRequest());
    const response = await get(query + stringParams, headers);
    return dispatch(actions.getSubcategoriesRequestSuccess(response));
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getSubcategoriesRequestFailed(err));
  }
}

async function getAudiencesPresets({
  params = {},
  headers = {},
  isNewBackendSearchOrFiltering = false
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiencesPresets);
    dispatch(actions.getPresetsRequest());
    const response = await get(query + stringParams, headers);
    // return dispatch(actions.getPresetsRequestSuccess(response));
    if (params.limit || params.offset) {
      return dispatch(
        actions.getPresetsRequestSuccess({
          next: response.next || "",
          results: response.results,
          isNewBackendSearchOrFiltering
        })
      );
    }
    return dispatch(
      actions.getPresetsRequestSuccess({
        results: response,
        isNewBackendSearchOrFiltering
      })
    );
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getPresetsRequestFailed(err));
  }
}

async function getAudiencesVariables({ params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.audiencesVariables);
    dispatch(actions.getVariablesRequest());
    const response = await get(query + stringParams, headers);
    return dispatch(actions.getVariablesRequestSuccess(response));
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getVariablesRequestFailed(err));
  }
}

async function getCountries({ params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.countriesWithAudience);
    dispatch(actions.getCountries());
    const response = await get(query + stringParams, headers);
    dispatch(
      actions.getCountriesSuccess(
        Array.isArray(response) ? response : [response]
      )
    );
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getCountriesFailed(err));
  }
}

async function getTags({ data = {}, headers = {} } = {}) {
  try {
    const query = url(queries.audienceTags);
    dispatch(actions.getTags());
    const response = await post(query, data, headers);
    dispatch(
      actions.getTagsSuccess(Array.isArray(response) ? response : [response])
    );
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getTagsFailed(err));
  }
}

// async function getMap({ data = {}, headers = {} } = {}) {
//   try {
//     const query = url(queries.audienceMap);
//     dispatch(actions.getMaps());
//     const response = await post(query, data, headers);
//     dispatch(
//       actions.getMapsSuccess(Array.isArray(response) ? response : [response])
//     );
//     return response;
//   } catch (error) {
//     const err = (error.response && error.response.data) || error;
//     return dispatch(actions.getMapsFailed(err));
//   }
// }

async function getStats({ data = {}, headers = {} } = {}) {
  try {
    const query =
      data.type === "audience"
        ? url(queries.audienceStats)
        : url(`${queries.presetStats}${data.presetId}`);

    dispatch(actions.getStats());
    const response =
      data.type === "audience"
        ? await post(query, data, headers)
        : await get(query, headers);

    dispatch(actions.getStatsSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getStatsFailed(err));
  }
}

async function getRegions({ data = {}, headers = {} } = {}) {
  try {
    const query = url(`${queries.regions}/?country=${data?.country}`);

    dispatch(actions.getRegions());
    const response = await get(query, headers);
    dispatch(actions.getRegionsSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getRegionsFailed(err));
  }
}

async function addRegion({
  data = {},
  headers = { "Content-Type": "multipart/form-data" }
} = {}) {
  try {
    const query = url(`${queries.regions}/`);

    dispatch(actions.addRegion());
    const response = await post(query, data, headers);
    dispatch(actions.addRegionSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.addRegionFailed(err));
  }
}

async function deleteInfoRegion({ data = {}, headers = {} } = {}) {
  try {
    const query = url(`${queries.regions}/${data.id}/delete-info`);

    dispatch(actions.deleteInfoRegion());
    const response = await get(query, headers);
    dispatch(actions.deleteInfoRegionSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.deleteInfoRegionFailed(err));
  }
}

async function deleteRegion({ data = {}, headers = {} } = {}) {
  try {
    const query = url(`${queries.regions}/${data.id}`);

    dispatch(actions.deleteRegion());
    const response = await remove(query, data, headers);
    dispatch(actions.deleteRegionSuccess(data.id));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.deleteRegionFailed(err));
  }
}

async function getRegionMap({ data = {}, headers = {} } = {}) {
  try {
    const id = data?.id !== undefined ? data?.id : "";

    const query = url(`${queries.regions}/${id}`);

    dispatch(actions.getRegionMap());
    const response = await get(query, headers);
    dispatch(actions.getRegionMapSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getRegionMapFailed(err));
  }
}

async function getDescription({ data = {}, headers = {} } = {}) {
  try {
    const query = url(queries.audiencePersonaDescription);
    dispatch(actions.getDescription());
    const response = await post(query, data, headers);
    dispatch(actions.getDescriptionSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getDescriptionFailed(err));
  }
}

async function attachFile({
  id = "",
  params = {},
  data = {},
  headers = {
    "Content-Type": "multipart/form-data"
  }
} = {}) {
  try {
    const stringParams = objectToParams(params);
    dispatch(actions.attachFileRequest());
    const query = url(queries.audienceFile, id);
    const response = await post(query + stringParams, data, headers);
    dispatch(actions.attachFileSuccess());
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.attachFileFailed(err));
  }
}

async function getDemographics({ params = {}, headers = {} } = {}) {
  try {
    const query = url(queries.audienceDemographics);
    dispatch(actions.getDemographics());
    const response = await post(query, params, headers);
    dispatch(
      actions.getDemographicsSuccess(
        Array.isArray(response) ? response : [response]
      )
    );
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getDemographicsFailed(err));
  }
}

async function shareAudienceValidateEmail({
  params: { audienceId, email } = {},
  headers = {}
} = {}) {
  try {
    const stringParams = objectToParams({ email, audience_id: audienceId });
    const query = url(queries.audienceCheckSharing);
    dispatch(AudienceSlice.actions.shareValidateEmailRequest());
    const response = await get(query + stringParams, headers);
    if (response.status) {
      dispatch(AudienceSlice.actions.shareValidateEmailSuccess(response));
    } else {
      dispatch(AudienceSlice.actions.shareValidateEmailFailure(response));
    }
    return response;
  } catch (error) {
    if (error.response.status === 500) {
      return dispatch(
        AudienceSlice.actions.shareValidateEmailFailure("Something went wrong")
      );
    }
    const err = (error.response && error.response.data) || error;
    return dispatch(AudienceSlice.actions.shareValidateEmailFailure(err));
  }
}

async function shareAudience({
  headers = {},
  data: { audienceId, email }
} = {}) {
  try {
    // const stringParams = objectToParams({ email, audience_id: audienceId });
    const query = url(queries.audienceShare);
    dispatch(AudienceSlice.actions.shareAudienceRequest());
    const response = await post(
      query,
      { audience_id: audienceId, email },
      headers
    );
    dispatch(AudienceSlice.actions.shareAudienceSuccess(response));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(AudienceSlice.actions.shareAudienceFailure(err));
  }
}

async function duplicateAudience({
  headers = {},
  data: { audienceId, isPreset },
  redirectTo
} = {}) {
  try {
    // const stringParams = objectToParams({ email, audience_id: audienceId });
    const query = url(queries.audienceDuplicate);
    dispatch(AudienceSlice.actions.duplicateAudienceRequest());
    // eslint-disable-next-line no-nested-ternary
    const data = isPreset
      ? { preset_id: audienceId }
      : { audience_id: audienceId };
    const response = await post(query, data, headers);

    // fixme, we might need to have more optional forwarding capability
    if (redirectTo) {
      redirectTo({
        pathname: audiencesCreateWithoutTemplate(response.id),
        state: { audience: response }
      });
    }
    dispatch(AudienceSlice.actions.duplicateAudienceSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(AudienceSlice.actions.duplicateAudienceFailure(err));
  }
}

async function getRemovedAudiences({ headers = {} } = {}) {
  try {
    const stringParams = objectToParams({ active: false });
    const query = url(queries.audiences);
    dispatch(AudienceSlice.actions.fetchRemovedAudiencesRequest());
    const response = await get(query + stringParams, headers);
    dispatch(AudienceSlice.actions.fetchRemovedAudiencesSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(AudienceSlice.actions.fetchRemovedAudiencesFailure(err));
  }
}

async function restoreAllAudiences({ headers = {} } = {}) {
  try {
    const query = url(queries.audiencesRestoreAll);
    dispatch(AudienceSlice.actions.restoreAllRemovedAudiencesRequest());
    const response = await post(query, {}, headers);
    dispatch(AudienceSlice.actions.restoreAllRemovedAudiencesSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(
      AudienceSlice.actions.restoreAllRemovedAudiencesFailure(err)
    );
  }
}

async function restoreAudience({
  headers = {},
  data: { audienceId } = {}
} = {}) {
  try {
    const query = url(queries.audiencesRestore);
    dispatch(AudienceSlice.actions.restoreAudienceRequest());
    const response = await post(query, { audience_ids: [audienceId] }, headers);
    dispatch(AudienceSlice.actions.restoreAudienceSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(AudienceSlice.actions.restoreAudienceFailure(err));
  }
}

async function removeAllAudiences({ headers = {} } = {}) {
  try {
    const query = url(queries.audiencesRemoveAll);
    dispatch(
      AudienceSlice.actions.permanentlyRemoveAllRemovedAudiencesRequest()
    );
    const response = await remove(query, headers);
    dispatch(
      AudienceSlice.actions.permanentlyRemoveAllRemovedAudiencesSuccess(
        response
      )
    );
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(
      AudienceSlice.actions.permanentlyRemoveAllRemovedAudiencesFailure(err)
    );
  }
}

async function fetchMap({ data = {}, headers = {} } = {}) {
  try {
    const query = url(queries.audienceMap);
    dispatch(actions.getMaps());
    const response = await post(query, data, headers);
    dispatch(
      actions.getMapsSuccess(Array.isArray(response) ? response : [response])
    );
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getMapsFailed(err));
  }
}

export default class AudiencesAPI {
  static get = getAudiences;

  static getSingleAudience = getAudienceById;

  static add = addAudience;

  static edit = editAudience;

  static remove = removeAudience;

  static search = searchAudiences;

  static categories = getAudiencesCategories;

  static subcategories = getAudiencesSubcategories;

  static presets = getAudiencesPresets;

  static variables = getAudiencesVariables;

  static countries = getCountries;

  static tags = getTags;

  static map = fetchMap;

  static samMap = getSamMapData;

  static stats = getStats;

  static attachFile = attachFile;

  static demographics = getDemographics;

  static personaDescription = getDescription;

  static regions = getRegions;

  static addRegion = addRegion;

  static deleteInfoRegion = deleteInfoRegion;

  static deleteRegion = deleteRegion;

  static regionMap = getRegionMap;

  //
  // static fetchMapLayout = fetchMapLayout;

  static shareAudienceValidateEmail = shareAudienceValidateEmail;

  static shareAudience = shareAudience;

  static duplicateAudience = duplicateAudience;

  static getRemovedAudiences = getRemovedAudiences;

  static restoreAllAudiences = restoreAllAudiences;

  static restoreAudience = restoreAudience;

  static removeAllAudiences = removeAllAudiences;
}
